import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "notification",
  listKey: "notifications",
  itemKey: "notification",
  getAll: types.GET_ALL_NOTIFICATIONS,
  getAllResponse: types.GET_ALL_NOTIFICATIONS_RESPONSE,
  getByIdResponse: types.GET_NOTIFICATION_BY_ID_RESPONSE,
  extra: {
    unreadCount: { type: types.GET_UNREAD_NOTIFICATION_COUNT_RESPONSE, initial: 0 },
  },
});
